import { ShipmentLeadTime } from 'app/modules/settings/domain/entity/ShipmentLeadTime';

export class ShipmentLeadTimeArray {

    constructor(public readonly items: ShipmentLeadTime[] = []) {}

    findByDayOfWeek(dayOfWeek: number): ShipmentLeadTime | undefined {
        return this.items.find((item) => item.dayOfWeek.value === dayOfWeek);
    }

}
